import { ExtendedNextLink } from 'components/Basic/ExtendedNextLink/ExtendedNextLink';
import { LogoMetadata } from 'components/Basic/Head/LogoMetadata/LogoMetadata';
import { B2bLogoIcon } from 'public/svg/IconsSvg';
import { ReactElement } from 'react';

export const B2bLogo = ({ linkText }: { linkText?: string }): ReactElement => (
    <ExtendedNextLink
        href="/"
        className="flex h-full max-w-[240px] items-center notVl:max-w-[200px] notVl:pl-2"
        title={linkText ?? undefined}
        type="static"
        key="logo"
    >
        <>
            <LogoMetadata />
            <div className="w-[115px] lg:w-[240px]">
                <B2bLogoIcon />
            </div>
        </>
    </ExtendedNextLink>
);
